import PageManager from '../page-manager';

export default class Errors extends PageManager {}



// WEBPACK FOOTER //
// ./assets/js/theme/errors.js